
import { Badge } from "@/components/ui/badge";
import { PropertyCardImage } from "./PropertyCardImage";
import { PropertyInvestmentOptions } from "./PropertyInvestmentOptions";
import type { Tables } from "@/integrations/supabase/types";
import { MapPin, Home as HomeIcon, BedDouble, Bath } from "lucide-react";

interface PropertyCardProps {
  property: Tables<"real_estate_properties">;
  showInvestmentOptions?: boolean;
}

export function PropertyCard({ property, showInvestmentOptions = true }: PropertyCardProps) {
  return (
    <div className="bg-white rounded-lg overflow-hidden border shadow-sm hover:shadow-md transition-all">
      <PropertyCardImage property={property} />
      
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <div>
            <h3 className="font-semibold text-lg line-clamp-1">{property.title}</h3>
            <div className="flex items-center text-muted-foreground text-sm">
              <MapPin className="h-3 w-3 mr-1" />
              <p className="line-clamp-1">{property.location}</p>
            </div>
          </div>
          
          <Badge variant={property.status === 'available' ? 'default' : 'secondary'} className={property.status === 'available' ? 'bg-green-500' : ''}>
            {property.status === 'available' ? 'Available' : property.status}
          </Badge>
        </div>
        
        <div className="flex flex-wrap gap-3 my-3 text-sm">
          <div className="flex items-center text-slate-700">
            <HomeIcon className="h-3.5 w-3.5 mr-1 text-slate-500" />
            <span>{property.size_sqm} sqm</span>
          </div>
          
          {property.bedrooms && (
            <div className="flex items-center text-slate-700">
              <BedDouble className="h-3.5 w-3.5 mr-1 text-slate-500" />
              <span>{property.bedrooms} {property.bedrooms === 1 ? 'Bed' : 'Beds'}</span>
            </div>
          )}
          
          {property.bathrooms && (
            <div className="flex items-center text-slate-700">
              <Bath className="h-3.5 w-3.5 mr-1 text-slate-500" />
              <span>{property.bathrooms} {property.bathrooms === 1 ? 'Bath' : 'Baths'}</span>
            </div>
          )}
        </div>
        
        <PropertyInvestmentOptions 
          property={property} 
          showInvestmentOptions={showInvestmentOptions}
        />
      </div>
    </div>
  );
}
